module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-42.8a419bb3.png";